import { cn, formatBRL } from '@/lib/utils';
import { Card, CardHeader, CardTitle } from '@/components/ui/card';

interface Props {
  computedProduction: number;
  reportedValue: number | null;
  tolerancePct: number;
  diffAbs: number | null;
  diffPct: number | null;
}

export function ConferenceCompare({
  computedProduction,
  reportedValue,
  tolerancePct,
  diffAbs,
  diffPct,
}: Props) {
  const withinTolerance =
    diffPct != null && Math.abs(diffPct) <= tolerancePct;
  const hasDiff = diffAbs != null && diffPct != null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Conferência</CardTitle>
        <p className="text-sm text-(--color-fg-muted)">
          Tolerância: ±{tolerancePct.toFixed(2).replace('.', ',')}%
        </p>
      </CardHeader>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <Cell label="Produção calculada" value={formatBRL(computedProduction)} />
        <Cell
          label="Relatório"
          value={reportedValue != null ? formatBRL(reportedValue) : '—'}
        />
        <Cell
          label="Diferença"
          value={
            hasDiff ? (
              <span
                className={cn(
                  'font-semibold',
                  withinTolerance ? 'text-emerald-600' : 'text-(--color-error)',
                )}
              >
                {formatBRL(diffAbs!)} ({diffPct!.toFixed(2).replace('.', ',')}%)
              </span>
            ) : (
              '—'
            )
          }
        />
      </div>

      {hasDiff ? (
        <p className="mt-3 text-sm">
          {withinTolerance ? (
            <span className="text-emerald-600">Dentro da tolerância.</span>
          ) : (
            <span className="text-(--color-error)">
              Acima da tolerância — libere com justificativa ou ajuste a produção.
            </span>
          )}
        </p>
      ) : null}
    </Card>
  );
}

function Cell({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="rounded-md border border-(--color-border) p-3">
      <p className="text-xs text-(--color-fg-muted)">{label}</p>
      <p className="mt-1 text-lg">{value}</p>
    </div>
  );
}
